import { createReducer, on } from '@ngrx/store';
import { LocalOptionValue } from 'src/app/core/local-option-value';
import * as fromRoot from '../reducers';
import * as AppActions from '../app/app.actions';
import { getSettingsOptions, getSettingsOptionsSuccess, getSettingsOptionsError, updateSettingsOptions, updateSettingsOptionsSuccess, updateSettingsOptionsError } from './settings-options.actions';

export interface SettingsOptionsState {
  settings: LocalOptionValue[];
  error: any;
  settingsOptionsCacheFlag: boolean;
}

export interface State extends fromRoot.State {
  settingsOptions: SettingsOptionsState;
}

const initialState: SettingsOptionsState = {
  settings: null,
  error: null,
  settingsOptionsCacheFlag: false,
};

export const settingsOptionsReducer = createReducer(
  initialState,

  on(getSettingsOptions, (state) => ({
    ...state,
    settingsOptionsCacheFlag: false, // Invalidate cache on fetch
  })),
  on(getSettingsOptionsSuccess, (state, { settingsOptions }) => ({
    ...state,
    settings: settingsOptions,
    settingsOptionsCacheFlag: true, // Validate cache on success
  })),
  on(getSettingsOptionsError, (state, { error }) => ({
    ...state,
    error,
    settingsOptionsCacheFlag: false, // Invalidate cache on error
  })),
  on(updateSettingsOptions, (state) => ({
    ...state,
  })),

  // Updates the list of options when a particular option was toggled
  // NOTE: must map between hidden and use attributes
  // TOOD: clean up once backend endpoint is fixed
  on(updateSettingsOptionsSuccess, (state, {option}) => {
    const updatedOption = {
      // Find the option from our list
      ...state.settings.find(opt => opt.id === option.optionId),
      // Map the "hidden" attribute to the internal "use" attribute (it is the opposite)
      use: !option.hidden
    };
    const allOtherOptions = state.settings.filter(opt => opt.id !== option.optionId);

    // Update state with the updated option, and add all the other (unchanged) elements
    return {...state, settings: allOtherOptions.concat([updatedOption])};
  }),
  on(updateSettingsOptionsError, (state, {error}) => ({
    ...state,
    error
  })),

  // Reset cache on app-level cache reset (triggered by auth changes, etc.)
  on(AppActions.cacheReset, (state) => ({
    ...state,
    settings: null,
    settingsOptionsCacheFlag: false,
  })),
);
